import {
  createStyles, Grid, makeStyles, TextField, Theme,
} from '@material-ui/core';
import React from 'react';
import { useFormContext, ControllerRenderProps, Controller } from 'react-hook-form';

interface IFormElementWithOneTextArea {
    labelInput: string;
    nameInput: string;
}

const FormElementWithOneTextArea : React.FC<IFormElementWithOneTextArea> = ({
  labelInput,
  nameInput,
}) => {
  const { control, errors } = useFormContext();
  const classes = useStyles();

  return (
    <Grid container={true} spacing={2} className={classes.formElementControl}>
      <Grid item={true} xs={12} md={4}>
        <div className={classes.formLabelInput}>
          <p>
            {labelInput}
          </p>
        </div>
      </Grid>
      <Grid item={true} xs={12} md={8}>
        <Controller
          name={nameInput}
          control={control}
          render={(
            { ref, ...rest }: ControllerRenderProps,
          ) => (
            <TextField
              {...rest}
              inputRef={ref}
              fullWidth={true}
              variant="outlined"
              inputProps={{ style: { textAlign: 'left' } }}
              className={classes.formInput}
              multiline={true}
              rows={6}
              error={!!errors[`${nameInput}`]}
              helperText={errors[`${nameInput}`]?.message || ''}
            />
          )}
        />
      </Grid>
    </Grid>
  );
};


const useStyles = makeStyles((theme: Theme) => createStyles({
  formElementControl: {
    marginBottom: '29px',
    marginLeft: '10px',
    width: 'calc(100% - 55px)',
    [theme.breakpoints.down('sm')]: {
      marginLeft: '0px',
      width: '100%',
    },
  },
  formLabelInput: {
    backgroundColor: '#EBEBEB',
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: '100%',
    [theme.breakpoints.down('sm')]: {
      height: '37px',
    },
    '& p': {
      fontSize: '18px',
      lineHeight: '26px',
      color: '#1a1a1a',
      letterSpacing: '-1.2px',
      fontWeight: 600,
      textAlign: 'center',
      paddingLeft: '12px',
      '& span': {
        fontSize: '14px',
        lineHeight: '21px',
        color: '#ffffff',
        backgroundColor: '#d0111b',
        marginRight: '0.3em',
      },
    },
  },
  formInput: {
    width: '100%',
    height: 'auto',
    borderRadius: '5px',
    appearance: 'none',
    fontSize: '18px',
    lineHeight: '26px',
    color: '#6F7878',
    letterSpacing: '0.8px',
    fontWeight: 400,
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
    },
  },
}));
export default FormElementWithOneTextArea;
